import React from 'react';
import {Box, Typography} from '@mui/material';
import ScopeSuppressedBanner from '../../DashboardCommon/ScopeSuppressedBanner.comp';

/**
 * Shared page shell for every Class Dashboard section.
 * Renders the page header (title + subtitle), optional tabs, and {children}.
 */
const ClassDashboardShell = ({tabs, children}) => {
    return (
        <Box>
            {/* Page header */}
            <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                mb: 4,
                pb: 2.5,
                borderBottom: '1px solid #E5E7EB',
                flexWrap: 'wrap',
                gap: 2,
            }}>
                <Box>
                    <Typography sx={{
                        fontSize: {xs: '20px', md: '26px'},
                        fontWeight: 800,
                        color: '#052F44',
                        lineHeight: 1.2,
                    }}>
                        Class Dashboard
                    </Typography>
                    <Typography sx={{fontSize: '14px', color: '#6A7282', mt: 0.5}}>
                        Child online safety readiness, cyber risk and support environment for students
                    </Typography>
                </Box>
            </Box>

            {/* Scores hidden when the class is under the n floor */}
            <ScopeSuppressedBanner/>

            {/* Persistent Tabs Navigation - rendered above content */}
            {tabs}

            {/* Section content rendered unconditionally so child pages/tabs run their own lifecycle */}
            {children}
        </Box>
    );
};

export default ClassDashboardShell;
